import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Varsayılan koordinatlar (örnek: İstanbul)
const defaultPosition = [41.015137, 28.97953];

// Leaflet icon fix
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Haritayı yeni konuma taşıyan bileşen
const MapUpdater = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    if (position) {
      map.setView(position, map.getZoom(), { animate: true });
    }
  }, [position, map]);

  return null;
};

const MapWithAddressInput = () => {
  const [address, setAddress] = useState(
    "Ferahevler Mahallesi Vatan Caddesi Fidan Sokak No:5"
  );
  const [position, setPosition] = useState(defaultPosition);

  useEffect(() => {
    if (address.length > 5) {
      fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(
          address
        )}&key=b099d66b45f84989879024346a33766a`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.results && data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry;
            setPosition([lat, lng]);
          }
        })
        .catch((err) => console.error("Geocode error:", err));
    }
  }, [address]);

  return (
    <div>
      <input
        type="text"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        placeholder="Adres girin..."
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      />

      <MapContainer
        center={position}
        zoom={17}
        style={{ height: "400px", width: "100%" }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>{address}</Popup>
        </Marker>
        <MapUpdater position={position} />
      </MapContainer>
    </div>
  );
};

export default MapWithAddressInput;
